<greco-payment-dispute-response-form
  [paymentDispute]="paymentDispute"
  [expanded]="expanded"
  [accountId]="_accountId$ | async"
></greco-payment-dispute-response-form>
